import React from "react";
import "video-react/dist/video-react.css";
import ReactPlayerCm from "components/shared/ReactPlayerCm";
import { Grid } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import StackCm from "components/shared/StackCm";
import TextFieldCm from "components/shared/TextField";
import { useForm } from "react-hook-form";
import { StyledGrid } from "./style";
import { useEffect } from "react";
import { StyledGlBtn } from "styles/globals";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import { getVideosRequest, updateVideosRequest } from "api/indexVideo";
import { useState } from "react";
import { IMG_BASE_URL } from "constants";
import { validateFile, validateImg } from "validations";
import Toast from "helper/toast";
import ProgressBarCM from "components/shared/ProgressBar";

const videoIndex = [
  { value: 1, title: "اول", size: 7 },
  { value: 2, title: "دوم", size: 5 },
  { value: 3, title: "سوم", size: 5 },
  { value: 4, title: "چهارم", size: 7 },
];

export default function VideosPage() {
  const [videosData, setVideosData] = useState(false);
  const {
    control,
    register,
    reset,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { loading, request, isUploading, setUploadProgress, uploadProgress } =
    useHttp();

  const onSubmit = async (data) => {
    let values = {};
    let validateVideo = true;
    let validateImage = true;
    let isLink = data.video_type === 2 ? true : false;
    if (data.video_type === 1) {
      validateVideo = data?.file?.length
        ? validateFile({
            file: data.file[0],
            limit: 100_000_000,
            title: "ویدئو",
            file_formats: ["mkv", "mp4", "ogg", "webm", "avi", "mov"],
          })
        : "*";
      validateImage = data?.image?.length ? validateImg(data.image[0]) : "*";
    }

    if (isLink && validateImage === "*" && !data?.link) {
      return Toast({
        type: "custom",
        title: "عکس یا لینک باید وارد شود",
        autoClose: 3000,
      });
    }
    if (validateVideo === "*" && validateImage === "*") {
      return Toast({
        type: "custom",
        title: "عکس یا ویدئو باید وارد شود",
        autoClose: 3000,
      });
    }

    values[`video_${data.select_index}`] =
      data.video_type === 1 ? data.file[0] : data.link;
    values[`image_${data.select_index}`] = data.image[0];

    const res =
      validateVideo && validateImage
        ? await request({
            url: () =>
              updateVideosRequest({ ...values }, (progress) =>
                setUploadProgress(progress)
              ),
            isFile: true,
          })
        : false;

    if (res) {
      Toast({ type: "success", title: "ویرایش" });
      reset({
        file: "",
        image: "",
        link: "",
        select_index: 1,
        video_type: 1,
      });
      getVideos();
    }
  };

  const getVideos = async () => {
    const res = await request({
      url: getVideosRequest,
    });
    setVideosData(res);
  };
  useEffect(() => {
    setValue("select_index", 1);
    setValue("video_type", 1);
    getVideos();
  }, []);

  return (
    <DrawerCM title="ویدئو ها">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <>
          <StackCm title="فیلد ها">
            <Grid container>
              <Grid item md={4} xs={12} p={1.5}>
                <TextFieldCm
                  id="select_index"
                  label={"جایگاه ویدئو"}
                  register={register}
                  errors={errors}
                  control={control}
                  type={"select"}
                  defaultValue={1}
                  selectItems={videoIndex}
                />
              </Grid>
              <Grid item md={4} xs={12} p={1.5}>
                <TextFieldCm
                  id="video_type"
                  label={"نوع"}
                  register={register}
                  errors={errors}
                  control={control}
                  type={"select"}
                  defaultValue={1}
                  selectItems={[
                    { value: 1, title: "ویدئو" },
                    { value: 2, title: "لینک" },
                  ]}
                />
              </Grid>
              {watch("video_type") === 1 ? (
                <Grid item md={4} xs={12} p={1.5}>
                  <TextFieldCm
                    id="file"
                    type="file"
                    label="آپلود ویدئو"
                    fileProps={{ file_formats: ["mkv", "mp4", "ogg", "webm", "avi", "mov"] }}
                    register={register}
                    errors={errors}
                  />
                </Grid>
              ) : (
                <Grid item md={4} xs={12} p={1.5}>
                  <TextFieldCm
                    id="link"
                    label="لینک ویدئو"
                    register={register}
                    errors={errors}
                  />
                </Grid>
              )}
              <Grid item lg={4} md={6} xs={12} p={1.5}>
                <TextFieldCm
                  id="image"
                  type="file"
                  label="عکس ویدئو"
                  fileProps={{ file_formats: ["png", "jpeg", "jpg", "webp"] }}
                  register={register}
                  errors={errors}
                />
              </Grid>
              {/* <Grid item lg={4} md={6} xs={12} p={1.5}>
                <TextFieldCm
                label="متن جایگزین (alt)"
                id="alt"
                register={register}
                errors={errors}
                />
              </Grid> */}

              <Grid item xs={12} p={1.5}>
                <StyledGlBtn onClick={handleSubmit(onSubmit)} />
              </Grid>
            </Grid>
          </StackCm>
          <Grid
            container
            sx={{
              margin: "auto",
            }}
            my={3}
            maxWidth={"md"}
            direction={"row-reverse"}
          >
            {videosData &&
              videoIndex.map((item, index) => (
                <StyledGrid
                  $isActive={watch("select_index") == item.value}
                  item
                  xs={item.size}
                  p={1.5}
                >
                  <div className="videoBox">
                    <ReactPlayerCm
                      poster={
                        IMG_BASE_URL + videosData[`image_${item.value}`]["url"]
                      }
                      src={
                        videosData[`video_${item.value}`].indexOf("http") != -1
                          ? videosData[`video_${item.value}`]
                          : IMG_BASE_URL + videosData[`video_${item.value}`]
                      }
                    />
                  </div>
                </StyledGrid>
              ))}
          </Grid>
        </>
      )}
    </DrawerCM>
  );
}
